const priceContracts: {cakeAddress: string, busdAddress: string, lpAddress:string} = {
  cakeAddress: '0x84Fd7CC4Cd689fC021eE3D00759B6D255269D538',
  busdAddress: '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56',
  lpAddress: '0xa992242749981Dd1b188AFD765D4710EEddA136e'
}

export default priceContracts
